import React from 'react'
import styled from 'styled-components'
import {FirebaseMessageRoomItemPayload} from 'types'
import {Paragraph} from 'common/components'

const StyledParagraph = styled(Paragraph)`
  white-space: pre-wrap;
`
export interface GiftShopMessageRoomContentItemChatProps {
  payload: FirebaseMessageRoomItemPayload['chat']
}

export default function GiftShopMessageRoomContentItemChat({
  payload: {message},
}: GiftShopMessageRoomContentItemChatProps) {
  return <StyledParagraph fontSize="m">{message}</StyledParagraph>
}
